import { Point } from "@/entities/chart/Point";

export class PointsCollection {
  private points: Point[] = [];

  constructor(points: Point[] = []) {
    this.points = points;
  }

  getPoints() {
    return this.points;
  }

  add(point: Point): void {
    this.points.push(point);
  }

  update(id: number, coords: [number, number]): void {
    let point = this.points.find(x => x.id === id);
    if (!!point) {
      point.xCoord = coords[0];
      point.yCoord = coords[1];
    }
  }

  findById(id: number): Point {
    const point = this.points.find(x => x.id === id);
    return point as Point;
  }

  toCoords(): [number, number][] {
    return this.points.map(x => [x.xCoord, x.yCoord]);
  }

  getLegend(): { id: number; color: string; name: string }[] {
    return this.points.map((x: Point) => ({
      id: x.id,
      color: x.color,
      name: x.name
    }));
  }

  isNearOfAnyPoint(coord: [number, number]): boolean {
    const xCoord = coord[0];
    const yCoord = coord[1];

    // 0.4 = radius * 2 * 10 / width
    // 0.6 = radius * 2 * 10 / height
    const deltaX = 0.23;
    const deltaY = 0.34;

    const point = this.points.find(
      x =>
        Math.abs(x.xCoord - xCoord) <= deltaX &&
        Math.abs(x.yCoord - yCoord) <= deltaY
    );

    return point != null;
  }
}
